
import * as Scales from './scales'
import agro from './agro.json'
import metal  from './metal.json'
import transports from './transports'
import waste from './waste'

export const Agro = agro
export const Metal = metal
export const Transports = transports
export const Waste = waste

export const Templates = {
    agro: Agro,
    metal: Metal,
    transports: Transports,
    waste: Waste
}

const start = { sectionOffset: 0, subSectionOffset: 0, stageOffset: 0}

export const parseOffsets = (offsetObject) => (
    {
        sectionOffset: parseInt(offsetObject.sectionOffset, 10),
        subSectionOffset: parseInt(offsetObject.subSectionOffset, 10),
        stageOffset: parseInt(offsetObject.stageOffset, 10)
    }
)

export const nextStage = (questionTree, current = { sectionOffset: 0, subSectionOffset:0, stageOffset: 0}) => {
    // console.log({questionTree, current})
    if (current === undefined) return start
    let sectionCount = questionTree.sections.length
    let currentSection = questionTree.sections[current.sectionOffset]
    let subSectionCount = currentSection.subSections? currentSection.subSections.length : 0
    let currentSubSection = currentSection.subSections? currentSection.subSections[current.subSectionOffset] : undefined
    let stageCount = currentSubSection? currentSubSection.stages.length : currentSection.stages.length
    let currentStage = currentSubSection? currentSubSection.stages[current.stageOffset] : currentSection.stages[current.stageOffset]
    console.log({current, sectionCount, subSectionCount, stageCount})
    if (current.stageOffset < stageCount - 1) {
        return { 
            ...current, 
            stageOffset: current.stageOffset + 1 
        }
    } else if (subSectionCount > 0 && current.subSectionOffset < subSectionCount - 1) {
        return { 
            ...current, 
            subSectionOffset: current.subSectionOffset + 1, 
            stageOffset: 0
        }
    } else if (current.sectionOffset < sectionCount - 1) {
        return {
            sectionOffset: current.sectionOffset + 1,
            subSectionOffset: 0,
            stageOffset: 0
        }
    } else {
        return undefined
    }
}


export const nextSubSection = (questionTree, current = { sectionOffset: 0, subSectionOffset:0 }) => {
    // console.log({questionTree, current})
    if (current === undefined) return start
    let sectionCount = questionTree.sections.length
    let currentSection = questionTree.sections[current.sectionOffset]
    let subSectionCount = currentSection.subSections? currentSection.subSections.length : 0
    let currentSubSection = currentSection.subSections? currentSection.subSections[current.subSectionOffset] : undefined
    console.log({current, sectionCount, subSectionCount})
    if (subSectionCount > 0 && current.subSectionOffset < subSectionCount - 1) {
        return { 
            ...current, 
            subSectionOffset: current.subSectionOffset + 1, 
        }
    } else if (current.sectionOffset < sectionCount - 1) {
        return {
            sectionOffset: current.sectionOffset + 1,
            subSectionOffset: 0,
        }
    } else {
        return undefined
    }
}

export const prevSubSection = (questionTree, current = { sectionOffset: 0, subSectionOffset:0 }) => {
    // console.log({questionTree, current})
    if (current === undefined) return start
    let sectionCount = questionTree.sections.length
    let currentSection = questionTree.sections[current.sectionOffset]
    let subSectionCount = currentSection.subSections? currentSection.subSections.length : 0
    let currentSubSection = currentSection.subSections? currentSection.subSections[current.subSectionOffset] : undefined
    // console.log({current, sectionCount, subSectionCount})
    if (subSectionCount > 0 && current.subSectionOffset > 0) {
        return { 
            ...current, 
            subSectionOffset: current.subSectionOffset - 1, 
        }
    } else if (current.sectionOffset > 0) {
        return {
            sectionOffset: current.sectionOffset - 1,
            subSectionOffset: questionTree.sections[current.sectionOffset - 1].subSections.length - 1,
        }
    } else {
        return undefined
    }
}


const subSectionCursorsForTree = (tree) => (
    tree.sections.reduce( (list, section, sectionOffset) => {
        return [ 
            ...list,
            ...section.subSections.map( (_, subSectionOffset) => ({ sectionOffset, subSectionOffset}) )
            ]
    }, [])
)


export const absoluteSubSectionOffsetForSubSectionWithCursorInTree = (cursor, tree) => {
    let flatListOfSubSectionCursors = subSectionCursorsForTree(tree)
    let absoluteOffset = flatListOfSubSectionCursors.findIndex( item => (
        item.sectionOffset === cursor.sectionOffset && item.subSectionOffset === cursor.subSectionOffset))
    console.log({cursor, flatListOfSubSectionCursors})
    return absoluteOffset
}

export const allQuestionsInStageAreAnswered = (stage) => {
    let possibleResponses = Scales.Options.map(scaleItem => scaleItem.value)
    return stage.questions.every(question => possibleResponses.includes(question.response))
}

export const allQuestionsInSubSectionAreAnswered = (subSection) => {
    let areStagesAnswered = subSection.stages.map(allQuestionsInStageAreAnswered)
    return areStagesAnswered.every( isStageAnswered => isStageAnswered)
}



const Regex = {
    Section: /^#[^#]*$/,
    SubSection: /^##[^#]*$/,
    Stage: /^###[^#]*$/
}

export const parseFile = (text = '') => {
    let lines = text.split('\n')
    let tree = {
        sections: []
    }
    let cursor = {
        section: undefined,
        subSection: undefined,
        stage: undefined
    }
    lines.forEach( line => {
        if (line.match(Regex.Section)) {
            let section = {
                title: line.substring(1),
                subSections: []
            }
            tree.sections.push(section)
            cursor.section = section
        } else if (line.match(Regex.SubSection)) {
            let subSection = {
                title: line.substring(2),
                stages: []
            }
            cursor.section.subSections.push(subSection)
            cursor.subSection = subSection
        } else if (line.match(Regex.Stage)) {
            let stage = {
                title: line.substring(3),
                questions: []
            }
            cursor.subSection.stages.push(stage)
            cursor.stage = stage
        } else {
            let question = {
                title: line
            }
            cursor.stage.questions.push(question)
        }
    })
    return tree
}

// console.log(parseFile(`#Toxicidade
// ##
// ###Aferição
// Mede a aplicação de substâncias activas
// `))


const scoreQuestion = (question, scaleOptions) => {
    let responseValue = question.response
    if (responseValue === undefined) return 0 
    let correspondingScaleOption = scaleOptions.find( scaleOption => scaleOption.value === responseValue)
    if (correspondingScaleOption) return correspondingScaleOption.score
    else return undefined
}

const add = (a, b) => a + b

const applicableQuestions = question => question.response !== Scales.EXCLUDE_VALUE
const sumArrayProp = (array, prop) => array.map ( item => item[prop]).reduce(add,0)

const colorCode = (percentage) => {
    if (percentage < 0.25) return 'danger'
    else if (percentage < 0.5) return 'warning'
    else if (percentage < 0.75) return 'info'
    else return 'success'
}

export const colorStyle = (percentage) => {
    if (percentage < 0.25) return '#dc3545'
    else if (percentage < 0.5) return '#ffc107'
    else if (percentage < 0.75) return '#17a2b8'
    else return '#28a745'
}

export const scoreTree = (tree, scaleOptions) => {
    tree.sections.forEach( section => {
        section.subSections.forEach( subSection => {
            subSection.stages.forEach( stage => {
                let questionsToScore = stage.questions.filter(applicableQuestions)
                questionsToScore
                    .forEach( question => {
                        question.score = scoreQuestion(question, scaleOptions)
                        question.actionRequired = Scales.scaleValueEntailsAction(question.required)
                })
                stage.score = sumArrayProp(questionsToScore, 'score')
                stage.maxScore = Scales.MAX_SCORE * questionsToScore.length
                stage.percentage = stage.score / stage.maxScore
                stage.colorCode = colorCode(stage.percentage)
                
            })
            subSection.score =  sumArrayProp(subSection.stages, 'score')
            subSection.maxScore = sumArrayProp(subSection.stages, 'maxScore')
            subSection.percentage = subSection.score / subSection.maxScore
            subSection.colorCode = colorCode(subSection.percentage)
            
        })
        section.score = sumArrayProp(section.subSections, 'score')
        section.maxScore = sumArrayProp(section.subSections, 'maxScore')
        section.percentage = section.score / section.maxScore
        section.colorCode = colorCode(section.percentage)
        
    })
    tree.score = sumArrayProp(tree.sections, 'score')
    tree.maxScore = sumArrayProp(tree.sections, 'maxScore')
    tree.percentage = tree.score / tree.maxScore
    tree.colorCode = colorCode(tree.percentage)
}

export const questionsInStage = (stage) => stage.questions.length
export const questionsInSubSection = (subSection) => subSection.stages.map(questionsInStage).reduce(add,0)
export const questionsInSection = (section) => section.subSections.map(questionsInSubSection).reduce(add,0)
export const stagesInSubSection = (subSection) => subSection.stages.length
export const stagesInSection = (section) => section.subSections.map(stagesInSubSection).reduce(add,0)
export const subSectionsInSection = (section) => section.subSections.length

export const numberOfSubSectionsInTree = (tree) => {
    let sections = tree.sections
    let subSectionsCount = sections.map(subSectionsInSection).reduce(add,0)
    return subSectionsCount
}

export const offsetOfQuestionInSubSection = (subSection, stageOffset, questionOffset) => {
    let stageLengths = subSection.stages.map( stage => stage.questions.length)
    let flatOffsets = stageLengths.map( (_, offset) => stageLengths.slice(0, offset).reduce( (sum, item) => sum += item, 0) )
    let baseOffset = flatOffsets[stageOffset]
    return baseOffset + questionOffset
}

const between = (value, lowThreshold, highThreshold) => value >= lowThreshold && value < highThreshold

export const sectionsRequiringActions = (sections) => {
    const _sections = [ ...sections] // prevent mutability issues with sort
    const orderedSections = _sections.sort( (a, b)  => a.percentage - b.percentage)
    const topSections = orderedSections.filter( section => between(section.percentage, 0.75, 1) )
    const midSections = orderedSections.filter( section => between(section.percentage, 0.5, 0.75)  )
    const bottomSections = orderedSections.filter( section => between(section.percentage, 0, 0.5) )
    return {
        topSections,
        midSections,
        bottomSections
    }
}

export const stagesRequiringActionInSubsection =  (subSection, maxStageCount = 2) => {
    const stagesRequiringAction = []
    subSection.stages.forEach( stage => {
        let isBelowThreshold = stage.percentage < 0.5
        let fitsMaxStageCount = stagesRequiringAction.length < maxStageCount
        let conditions = [isBelowThreshold, fitsMaxStageCount]
        let isTrue = (condition) => condition === true
        if (conditions.every(isTrue)) {
            stagesRequiringAction.push(stage)
        }
    })
    // console.log({stagesRequiringAction})
    return stagesRequiringAction
}

export const questionsRequiringActionInStage = (stage) => {
    let filteredQuestions = stage.questions.filter( question => Scales.scaleValueEntailsAction(question.response))
    // console.log({filteredQuestions})
    return filteredQuestions
}

export const recommendationsForSubSection = (subSection) => {
    let relevantStages = stagesRequiringActionInSubsection(subSection)
    let relevantQuestions = relevantStages.reduce( (questionList, stage) => {
        return [
            ...questionList,
            ...questionsRequiringActionInStage(stage)
        ]
    }, [])
    let relevantRecommendations = relevantQuestions.map( question => question.recommendation)
    return relevantRecommendations
}

export const generateRandomResponseForAllQuestionsInTree = (tree) => {
    tree.sections.forEach(section => {
        section.subSections.forEach(subSection => {
            subSection.stages.forEach(stage => {
                stage.questions.forEach(question => {
                    question.response = Scales.randomResponse()
                })
            })
        })
    })
}


// WEBPACK FOOTER //
// ./src/questions.js